import { useAppStore } from '../../store/useAppStore'
import { useTelegramWebApp } from '../../hooks/useTelegramWebApp'
import {
  ProfileHeader,
  SubscriptionSection,
} from './components'
import './ProfilePage.css'

const ProfilePage = () => {
  const { user, subscription, hasActiveSubscription } = useAppStore()
  const { hapticFeedback } = useTelegramWebApp()

  // Обработчики событий
  const handleSubscribeClick = () => {
    hapticFeedback('light')
    // TODO: Реализовать переход к покупке подписки
  }

  const handleSettingsClick = () => {
    hapticFeedback('light')
    // Переход к техподдержке в Telegram
    window.open('https://t.me/secretchathelp', '_self')
  }

  return (
    <div className="profile-page">
      <ProfileHeader user={user} />

      <SubscriptionSection
        hasActiveSubscription={hasActiveSubscription}
        subscription={subscription}
        onSubscribeClick={handleSubscribeClick}
        onSettingsClick={handleSettingsClick}
      />
    </div>
  )
}

export default ProfilePage
